import Footer from './Footer';
import ModalExpiringCard from './ModalExpiringCard';
import {
  EXPIRED_CARD_BANNER,
  FOOTER_TYPES,
  IHeader,
} from '@monofront/business/constants';
import Header from './Header';
import ModalFreshMobile from '@features/Fresh/ModalFreshMobile';
import { useMediaQuery } from '@monofront/business/hooks';
import Head from 'next/head';
import getConfig from 'next/config';
import { useFeatureIsOn } from '@monofront/business/contexts';
import { useLayoutRefs } from '@context/layoutRefs';
import UpdatePaymentMethodPanel from '@screens/ManageSubscription/UpdatePaymentMethodPanel';
import { useCardInformation } from '@hooks/useCardInformation';
import { useState } from 'react';

interface IPageProps {
  footerType?: FOOTER_TYPES;
  header?: IHeader;
  [key: string]: any;
}

interface ILayoutProps {
  children: React.ReactNode;
  pageProps?: IPageProps;
}

const {
  publicRuntimeConfig: { iosAppId },
} = getConfig();

const Layout: React.FC<ILayoutProps> = ({ children, pageProps }) => {
  const { mainBottomRef } = useLayoutRefs();
  const isMobileWebsite = useMediaQuery(800);
  const isABTestEnabled = useFeatureIsOn(pageProps?.featureFlagKey || '');
  const isExpiredCardBannerEnabled = useFeatureIsOn(EXPIRED_CARD_BANNER);
  const [isPaymentMethodPanelOpen, setIsPaymentModalOpen] = useState(false);

  const { isDunning, getPaymentQuery, refetchPaymentQuery } =
    useCardInformation();

  return (
    <>
      <Head>
        {/* The banner will flicker in preprod because the app isn't published */}
        {iosAppId && (
          <meta
            name="apple-itunes-app"
            content={`app-id=${iosAppId}, affiliate-data=pt=123530141&ct=smart_banner&mt=8`}
          />
        )}
      </Head>
      {isMobileWebsite && <ModalFreshMobile />}
      {!isExpiredCardBannerEnabled && (
        <ModalExpiringCard onCardReplace={() => setIsPaymentModalOpen(true)} />
      )}
      <UpdatePaymentMethodPanel
        isOpen={isPaymentMethodPanelOpen}
        isDunning={isDunning}
        closeSidePanel={() => setIsPaymentModalOpen(false)}
        refetchPaymentQuery={refetchPaymentQuery}
        primaryPaymentMethod={getPaymentQuery?.getCurrentPaymentMethod}
      />
      <Header
        content={
          isABTestEnabled && pageProps?.abTestHeader
            ? pageProps.abTestHeader
            : pageProps?.header
        }
      />
      <main id="global-main" className="tw-scroll-mt-[300px]" tabIndex={-1}>
        {children}
        <div ref={mainBottomRef} />
      </main>
      <Footer
        type={
          isABTestEnabled && pageProps?.abTestFooterType
            ? pageProps.abTestFooterType
            : pageProps?.footerType
        }
      />
      <style jsx>{`
        #global-main {
          outline: none;
        }

        @media (max-width: 800px) {
          main {
            min-height: calc(100vh - var(--mobile-header-full-height));
          }
        }
      `}</style>
    </>
  );
};

export default Layout;
